import styled from "styled-components";

import { FlexContainer, FlexDiv, FlexSection } from "@/components/Atoms/Box";
import { Typography } from "@/foundation/Typography/V2";

export const Subtitle = styled(Typography)``;

export const Wrapper = styled(FlexSection)`
  padding: 82px 0;
  background-color: ${({ theme }) => theme.colorsV2.shyft.gold_2};
  ${Subtitle} {
    * {
      font-size: inherit;
      font-family: inherit;
      color: inherit;
    }
  }
  @media only screen and (max-width: 992px) {
    padding: 40px 0;
  }
`;

export const Container = styled(FlexContainer)`
  align-items: center;
  @media only screen and (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const TextBox = styled(FlexDiv)`
  flex-direction: column;
  flex: 1;
  padding: 0 56px;
  gap: 8px;
  @media only screen and (max-width: 992px) {
    padding: 0 24px;
  }
`;

export const Link = styled(Typography)``;
